import React from 'react';
import { Box, Skeleton } from '@mui/material';

/**
 * Skeletons shown while a PRESENTATION project source is still being extracted
 * (status === PENDING) and the corresponding block field has not loaded yet.
 * Rendered only while extracting (status === PENDING)
 */

const PILL_RADIUS = '17.5px';

// Two-line text placeholder used for both block text and slide notes.
export const TextLinesSkeleton = () => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      gap: '12px',
      width: '100%',
    }}
  >
    <Skeleton
      variant="rounded"
      animation="wave"
      sx={{
        height: '12px',
        width: '200px',
        maxWidth: '100%',
        borderRadius: PILL_RADIUS,
      }}
    />
    <Skeleton
      variant="rounded"
      animation="wave"
      sx={{ height: '13px', width: '100%', borderRadius: PILL_RADIUS }}
    />
  </Box>
);

export const ConfigToolbarSkeleton = () => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
    <Skeleton variant="circular" animation="pulse" width={28} height={28} />
    <Skeleton
      variant="rounded"
      animation="wave"
      sx={{ width: '90px', height: '12px', borderRadius: PILL_RADIUS }}
    />
  </Box>
);

export const BlockActionsSkeleton = () => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
    <Skeleton variant="circular" animation="wave" width={24} height={24} />
    <Skeleton variant="circular" animation="wave" width={24} height={24} />
  </Box>
);

// Slide thumbnail placeholder in the block list (matches .slide-thumbnail dims).
export const SlideThumbnailSkeleton = () => (
  <Skeleton
    variant="rounded"
    animation="wave"
    sx={{ flexShrink: 0, width: '214px', height: '120px', borderRadius: '8px' }}
  />
);

// Gradient fill for a slide image whose container already provides the border /
// radius / aspect-ratio (side panel, non-expanded).
export const SlideImageFill = () => (
  <Skeleton
    variant="rectangular"
    animation="wave"
    sx={{ width: '100%', height: '100%' }}
  />
);

// Standalone slide preview placeholder (side panel, expanded).
export const SlidePreviewImageSkeleton = () => (
  <Box sx={{ width: '100%', aspectRatio: '368 / 208', flexShrink: 0 }}>
    <Skeleton
      variant="rounded"
      animation="wave"
      sx={{ width: '100%', height: '100%', borderRadius: '12px' }}
    />
  </Box>
);
